import { FileText, Mail, Truck, ExternalLink } from "lucide-react";

export function TaskChip({ t }) {
  return (
    <div className="bg-white border border-[#E5E3DB] rounded px-2 py-1.5 text-xs" data-testid={`garv-taskchip-${t.id}`}>
      <div className="font-medium text-[#1A1A18]">{t.title}</div>
      <div className="text-[#68665E] mt-0.5 flex flex-wrap gap-x-2 items-center">
        <span>{t.assignee_name || "Unassigned"}</span>
        {t.due_date && <span>· due {t.due_date}</span>}
        {t.links?.lr_number && <span className="inline-flex items-center gap-0.5"><Truck className="w-3 h-3" /> {t.links.lr_number}</span>}
        {t.links?.email_subject && <span className="inline-flex items-center gap-0.5"><Mail className="w-3 h-3" /> email</span>}
        {t.links?.drive_file_name && <span className="inline-flex items-center gap-0.5"><FileText className="w-3 h-3" /> doc</span>}
      </div>
    </div>
  );
}

export function DocChip({ d }) {
  return (
    <div className="bg-white border border-[#E5E3DB] rounded px-2 py-1.5 text-xs flex items-center gap-2" data-testid="garv-docchip">
      {d.source === "email" ? <Mail className="w-3.5 h-3.5 text-[#C84B31] shrink-0" /> : <FileText className="w-3.5 h-3.5 text-[#C84B31] shrink-0" />}
      <span className="truncate flex-1 text-[#1A1A18]">{d.name}{d.email_subject ? ` · ${d.email_subject}` : ""}</span>
      {d.web_view_link && <a href={d.web_view_link} target="_blank" rel="noreferrer" className="text-[#68665E] hover:text-[#C84B31]"><ExternalLink className="w-3.5 h-3.5" /></a>}
    </div>
  );
}
